// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline-3yQ8Aa1t","tit_tag":"tit_tag-24pukfAj","tit_time":"tit_time-1wdKGbNe","time":"time-FG38DPTN","num":"num-474i2A-I"};